// src/features/locker-types/hooks/useLockerTypeValidation.ts

import { useTranslate } from 'react-admin';

export const useLockerTypeValidation = () => {
  const translate = useTranslate();

  const validateName = (value?: string): string | undefined => {
    if (!value || value.trim().length < 2) {
      return translate('resources.locker-types.validation.name_required', 'El nombre es obligatorio (mín. 2 caracteres)');
    }
    if (value.trim().length > 100) {
      return translate('resources.locker-types.validation.name_max_length', 'El nombre no puede exceder los 100 caracteres');
    }
    return undefined;
  };

  const validateDescription = (value?: string): string | undefined => {
    if (value && value.length > 500) {
      return translate('resources.locker-types.validation.description_max_length', 'La descripción no puede exceder los 500 caracteres.');
    }
    return undefined;
  };

  const validateHotelId = (value?: string): string | undefined => {
    if (!value) {
        return translate('resources.locker-types.validation.hotel_required', 'Debe seleccionar un hotel.');
    }
    return undefined;
  }

  return { validateName, validateDescription, validateHotelId };
};